import { TEnvironment } from './environment.type';
import { EnvironmentFactory } from './EnvironmentFactory';

export const environment: TEnvironment = EnvironmentFactory({
  servicesDomain: 'https://main-backend-latest.onrender.com',
  webpageDomain: window.location.origin,
  backendDomain: window.location.origin + '/api',
});
